import { home } from "../content/home";
import { useContent, Rich } from "../ui/helpers";

/* "Problems it helps with" — before/after comparison rows. Text: content/home.js → problems */
export function Problems() {
  const c = useContent(home).problems;
  return (
    <section className="navy-1 sec problems" id="problems" aria-labelledby="problems-title">
      <div className="k-wrap">
        <div className="sec-head rv">
          <div>
            <p className="k-label">{c.eyebrow}</p>
            <h2 id="problems-title" className="h-sec" style={{ marginTop: 16 }}>{c.title}</h2>
          </div>
          <p>{c.lead}</p>
        </div>
        <table className="cmp rv">
          <thead><tr><th scope="col">{c.head[0]}</th><th scope="col">{c.head[1]}</th></tr></thead>
          <tbody>
            {c.rows.map(([a, b]) => (
              <tr key={a}><td data-label={c.head[0]}><Rich text={a} /></td><td data-label={c.head[1]}><Rich text={b} /></td></tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}
